/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ service: NonNullable<unknown>, city: NonNullable<unknown> }} Directory_Title_Service_CityInputs */

const en_directory_title_service_city = /** @type {(inputs: Directory_Title_Service_CityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service} · ${i?.city}`)
};

const pl_directory_title_service_city = /** @type {(inputs: Directory_Title_Service_CityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service} · ${i?.city}`)
};

/**
* | output |
* | --- |
* | "{service} · {city}" |
*
* @param {Directory_Title_Service_CityInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_title_service_city = /** @type {((inputs: Directory_Title_Service_CityInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Title_Service_CityInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_title_service_city(inputs)
	return en_directory_title_service_city(inputs)
});